<!-- Reiter „Wissensbasis" von Agent › Wissen: Menü, Karte und Reiter stellt
     der Gastgeber (TutorKnowledgeComponent), hier nur Suche und Inhalt. -->
<section class="kb-section" alAnchor="agent.knowledge-link">
  <!-- Kopf: Titel und Hinweis links, die Suche rechts daneben — der Text
       läuft nur bis zur Suche und spart die eigene Zeile darüber
       (Marcel, 30.09.2026). Die Suche filtert beide Sektionen. -->
  <div class="kb-section__head">
    <div class="kb-section__intro">
      <!-- "Wissensbasis – Verknüpfung" (tutorTitle) is hidden for Alpha Twin
           bots (alpha_dozent template). The Twin only has one KB
           picker, so the section heading is redundant and was
           confusing admins — see knowledge-base.component.ts:isTwin. -->
      <h5 *ngIf="!isTwin" class="kb-section__title">
        {{ 'pages.tutors.knowledgeBase.tutorTitle' | translate }}
      </h5>
      <!-- Erst die Ordner (das, was hier passiert), dann der Verweis auf
           Platzierungen für den Kurs-Sync — nur, wenn die Organisation
           Platzierungen hat (hasPlacements). -->
      <p class="kb-section__hint">
        <ng-container *ngIf="isTwin; else tutorHint">{{
          'pages.tutors.knowledgeBase.tutorHintTwin' | translate
        }}</ng-container>
        <ng-template #tutorHint
          >{{ 'pages.tutors.knowledgeBase.tutorHint' | translate
          }}<ng-container *ngIf="hasPlacements">
            {{ 'pages.tutors.knowledgeBase.tutorHintPlacementsBefore' | translate
            }}<a routerLink="/tutors/placements">{{ 'pages.tutors.menu.placements' | translate }}</a
            >{{ 'pages.tutors.knowledgeBase.tutorHintPlacementsAfter' | translate }}</ng-container
          ></ng-template
        >
      </p>
    </div>
    <nb-form-field class="search-field">
      <input
        type="text"
        nbInput
        [placeholder]="'menu.searchPlaceholder' | translate"
        [(ngModel)]="searchText"
      />
      <button nbSuffix nbButton ghost>
        @if(searchText.length > 0) {
          <nb-icon icon="close-outline" (click)="searchText = ''"></nb-icon>
        } @else {
          <nb-icon icon="search-outline"></nb-icon>
        }
      </button>
    </nb-form-field>
  </div>
  <!-- Erstes Wissen eines neuen Agents → „Nur Wissensbasis" (Migration 224).
       Sagt, was passiert ist und was es auf „Quellen & Suche" sonst gibt;
       bleibt stehen, bis es weggeklickt oder die Seite verlassen wird. -->
  <div *ngIf="modeSwitched" class="kb-mode-note" role="status">
    <nb-icon icon="info-outline" class="kb-mode-note__icon"></nb-icon>
    <p class="kb-mode-note__text">
      <strong>{{ 'pages.tutors.knowledgeBase.modeSwitched.title' | translate }}</strong>
      {{ 'pages.tutors.knowledgeBase.modeSwitched.textBefore' | translate
      }}<a [routerLink]="['/tutors', tutor?.id, 'knowledge', 'usage']">{{
        'pages.tutors.knowledgeTabs.usage' | translate
      }}</a>{{ 'pages.tutors.knowledgeBase.modeSwitched.textAfter' | translate }}
    </p>
    <button
      type="button"
      nbButton
      ghost
      size="tiny"
      class="kb-mode-note__close"
      [attr.aria-label]="'pages.tutors.knowledgeBase.modeSwitched.close' | translate"
      [nbTooltip]="'pages.tutors.knowledgeBase.modeSwitched.close' | translate"
      (click)="modeSwitched = false"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </div>
  <app-knowledge-select-form
    alAnchor="agent.knowledge-folders"
    [tutor]="tutor"
    [searchText]="searchText"
    purpose="tutor"
    (knowledgeModeSwitched)="onKnowledgeModeSwitched()"
  ></app-knowledge-select-form>
</section>

<section class="kb-section" *ngIf="lecturerOn">
  <h5 class="kb-section__title">
    {{ 'pages.tutors.knowledgeBase.dozentTitle' | translate }}
  </h5>
  <p class="kb-section__hint">
    {{ 'pages.tutors.knowledgeBase.dozentHint' | translate }}
  </p>
  <app-knowledge-select-form
    [tutor]="tutor"
    [searchText]="searchText"
    purpose="dozent"
  ></app-knowledge-select-form>
</section>
